import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || 'null'));
  const [suspendMessage, setSuspendMessage] = useState('');

  const login = (tokenData, userData) => {
    localStorage.setItem('token', tokenData);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(tokenData);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  // Escucha el aviso global de "cuenta suspendida" (disparado desde apiFetch
  // al recibir ese código, sin importar en qué pantalla estuviera el usuario)
  // y cierra la sesión automáticamente en toda la app.
  useEffect(() => {
    const handleSuspended = (e) => {
      setSuspendMessage(e.detail || 'Tu cuenta está en revisión.');
      logout();
    };
    window.addEventListener('cuenta-suspendida', handleSuspended);
    return () => window.removeEventListener('cuenta-suspendida', handleSuspended);
  }, []);

  return (
    <AuthContext.Provider value={{
      token, user, login, logout, isLoggedIn: !!token,
      suspendMessage, clearSuspendMessage: () => setSuspendMessage(''),
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}